import React, { Component } from 'react';
import './footer.css';
import { connect } from 'react-redux';
import MyPATLink from '../../common/MyPATLink';
import { UserData } from '../../login/types/UserData';
import { Redirect } from 'react-router-dom';
import { components as headerComponents } from '../../header';

const { Header } = headerComponents;
//@ts-ignore
interface LoginProps extends WithStyles<typeof styles> {
  userData: UserData,
  setSelectedRole: Function,
  history: any,
}

interface LoginState {
}

class terms extends Component<LoginProps, LoginState> {
  constructor(props: LoginProps, state: LoginState) {
      super(props);
  }
  state = {};

  redirection() {
    if (this.props.userData.isAuthenticated) {
      <Redirect to='/mylibrary' />
    } else {
      <Redirect to='/login' />
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    const { userData } = this.props;
    return (
      <>{
        this.props.userData.isAuthenticated && <Header/>
      }
      <div className={`containerMain ${this.props.userData.isAuthenticated ? 'newMain' : ''}`}>
        <div className="headerMain">
          <span>
            <MyPATLink align="right" variant="body2" onClick={this.redirection} to={''}><img src="/assets/svg/authors-new-logo.svg" alt="glorifire icon" /></MyPATLink>
          </span>
          <span>
            <MyPATLink className="linkButton" align="right" variant="body2" onClick={this.redirection} to={''}>Login</MyPATLink>
          </span>
        </div>
        <div className="container">
          <h2>Terms of Use</h2>
          <p>
            Welcome to Glorifire Authors, an online platform for Educational
            Authors, supplementing the pursuit of academic excellence.
            Please understand that your use of Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>or any of the products or services offered on the website or
            application (collectively, the "Services") is subject to these
            terms of use (collectively, the "Terms"). By using or visiting
            the website (or application), the user, as defined herein below,
            agrees to be bound by these terms of use. If you do not agree
            with any provision of these terms of use, then, you must
            discontinue using the website (or application) and/or
            discontinue availing the services provided by the website (or
            application). We reserve the right to modify the terms of use,
            at any time, without taking your prior consent, or sending
            notification, as the case may be and such modified version of
            the terms of use shall be effective immediately upon its
            publication on the website (or application) and will supersede
            all previous versions thereof. You, hereby, agree to regularly
            review the terms to keep yourself apprised of any such changes.
            Your continued use of the website (or application) constitutes
            your binding acceptance of these terms, including any
            modifications thereto. These terms of use and the provision of
            our services shall be governed by and construed in accordance
            with Indian law. Any dispute arising out of these terms of use
            shall exclusively be submitted to the competent courts in New
            Delhi, India.
          </p>
          <p>
            <b>1. Your Acceptance</b>
            Welcome to<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>(Glorifire Authors) (the “website”) managed and operated by
            Edfora (“EDFORA”). By using and/or visiting this website/
            webpage (collectively, including all “Content” on<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>(website), you signify your assent to both these terms and
            conditions (the "Terms of Service") and the terms and conditions
            of privacy notice, which are published at<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>
            and which are incorporated herein by reference. If you do not
            agree to any of these terms, then please do not use the "<a href="https://authors.glorifire.com">
              https://authors.glorifire.com</a>the website or access the contents therein."
            <br />
            <br />
            <b>2. https://authors.glorifire.com</b>
            These terms of use shall apply to all users of Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, including users who are also contributors of any type of
            content, information, and other materials or services on<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>the website The Glorifire Authors platform
            <a href="https://authors.glorifire.com">
              https://authors.glorifire.com
            </a>
            may contain links to third party/ websites that are not owned or
            controlled by<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, which has no control over and assumes no responsibility for
            the content, privacy policies or practices of any such third
            party / websites. In addition,<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>will not and cannot censor or edit the content of any
            third-party / website. By using the website, you expressly
            relieve Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>from any and all liability arising from your use of any
            third-party contents/ website. Accordingly, we suggest you to be
            aware when you leave the "<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>" and to read the terms and conditions and privacy policy of any
            other content/ website that you visit.
            <br />
            <br />
            <b>3. Registration</b>
            You need to get yourself registered with the website for
            accessing contents of the website. The services of this website
            are available only to the registered users (“Users” or “You”) on
            a single user basis, for a particular period of time on making
            the stipulated payment and abiding by the applicable terms and
            conditions. The said services are personal in nature and cannot
            be assigned or transferred to or shared with any other person.
            We reserve the right to deny registration or access to the
            website, either completely or to any specific section or service
            provided therein, at any time and without being under any
            obligation to provide any reason(s) or notice of any nature
            whatsoever to the user. Please note that all information
            submitted for purposes of registration of the website shall be
            dealt with, in accordance with our privacy policy, provided
            hereinafter.
            <br />
            <br />
            By registering yourself as a user and subscribing to avail the
            services of this Website, you are deemed to have read,
            understood and agreed to fully abide by all the terms and
            conditions of the Website as contained herein. Further, by
            registering on the Website, you agree to:
            <ul>
              <li>
                Make your contact details available to us and our associates
                so that you may be contacted by us for education information
                through email, telephone and/or SMS;
              </li>
              <li>
                Receive promotional mails/special offers from the website or
                any of its partner websites; and/ or
              </li>
              <li>
                Be contacted by us in accordance with the privacy settings
                set by you.
              </li>
            </ul>
            The right to use the services of the website is on revocable
            license / permission basis as per the terms and conditions
            contained herein. Except the usage of the services during the
            license period, the registered users shall not have any right or
            title over the website or any of its contents. We reserve our
            right to modify or terminate the Glorifire Authors service for
            any reason, without prior notice, without any liability to us
            for any reason whatsoever. In order to use Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>online services (or application), you must obtain access to the
            World Wide Web, either directly or through devices that access
            web-based content, and pay any service fees associated with such
            access. In addition, you will need to have access to all
            equipment necessary to make such a connection to the World Wide
            Web, including a computer, a phone, tablet and modem or other
            access devices.
            <br />
            <br />
            <b>Who May Use our Services?</b>
            You may use our services provided you are eligible to validly
            enter in a binding contract with Glorifire Authors in compliance
            with these terms and all applicable laws. When you create your
            Glorifire Authors account, and subsequently when you use certain
            features, you must provide us with accurate and complete
            information, and you agree to update your information to keep it
            accurate and complete. Our decision about grant of access to the
            services of Glorifire Authors is our sole prerogative and our
            decision in this respect shall be final and binding. You agree
            that Glorifire Authors reserves its right to take all necessary
            measures to deny access to its services or the termination of
            services, if the terms and conditions of the present agreement
            are not complied with or are contravened or there is any
            violation of copyright, trademark or other valuable proprietary
            right as described in this agreement. In order to use the
            service, you must obtain access to the World Wide Web, either
            directly or through devices that access web-based content, and
            pay for the service fees associated with such access. In
            addition, you must have all equipment necessary to make such a
            connection to the World Wide Web, including a computer phone or
            tablet and modem or other access devices; that do not form a
            part of the service.
            <br />
            <br />
            <b>Our License to You</b>
            Subject to these terms and our policies (including the
            Acceptable Privacy Policy, Edfora's B2B Partner Institutions'
            user code for their students and course-specific eligibility
            requirements and other terms incase our license to you is
            extended by such Institutions), we, Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, hereby grant you a limited, personal, revocable, legal,
            ethical, non exclusive, non transferable, non commercial, non
            vindictive, non discriminatory and non racial use of the
            contents of our website. You will not copy or distribute any
            part of the website (or application) in any medium without prior
            written authorization from Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>; you shall also not alter or modify any part of the website (or
            application) other than as may be reasonably necessary to use
            the website (or application) for its intended purpose.
            <br />
            <br />
            <b>How you may use our services</b>
            In order to access any features of the website, you will have to
            create an account (including through your institution). You
            shall never use another's account without written authorization
            in this regard from both, such other users and Glorifire Authors
            platform. When creating your account, you must provide accurate
            and complete information. You are solely responsible for the
            activity that occurs on your account, and you must keep your
            account password secure. You must notify Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>immediately in case of any breach of security or unauthorized
            use of your account. You understand that Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>will not be liable for your losses caused by any unauthorized
            use of your account; however you may be liable for the losses
            and claims of Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>or others due to such unauthorized use. You agree not to use or
            launch any automated system, including without limitation,
            "robots", "spiders", "offline readers", etc. that accesses the
            website in a manner that sends more request messages to
            Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>servers in a given period of time than a human can reasonably
            produce in the same period by using a conventional on-line web
            browser or application. Notwithstanding the foregoing, Glorifire
            Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>grants the operators of public search engines permission to use
            spiders to copy materials from the site for the sole purpose of
            creating publicly available searchable indices of the materials,
            but not caches or archives of such materials. This website (or
            application) reserves the right to revoke these exceptions
            either generally or in specific cases. You agree not to collect
            or harvest any personally identifiable information, including
            account names, from the website (or application), nor to use the
            communication systems provided by the website (or application)
            for any commercial solicitation purposes. You agree not to
            solicit, for commercial purposes, any users of the website (or
            application) with respect to their user submissions.<br /><br />
            <b>General terms of use for content</b>
            <ol>
              <li>
                We have taken reasonable care in reviewing the contents of
                the website (or application). In view thereof, you agree and
                understand that the contents reflect our or our associates
                expert(s) opinion regarding subject matters contained on the
                site and such opinion vary from expert to expert and
                sometimes with passage of time. You understand that answers,
                information, material and content have been posted by us on
                Glorifire Authors by exercising due diligence and care and
                are correct and true to the best of our knowledge and
                intent. You also agree to independently verify the
                authenticity and veracity of the answers, information,
                material and content posted on the site. We do not hold any
                responsibility as to the authenticity and veracity of the
                answers, information, material and content on the site. You
                hereby agree to indemnify the site (platform or application)
                against all actions brought out in this regard. You shall
                not construe answers, information, material and content on
                the site as final without exercising necessary due diligence
                at your end. You alone shall be responsible for any action
                taken by you on the basis of the information contained on
                the site and we will not be liable in any manner for the
                consequences of such action/inaction by you.
              </li>
              <li>
                You hereby agree and undertake that the time limits, if any,
                stipulated on the website (or application) for providing the
                answers to the queries of the user are only indicative and
                not definitive. You understand that the queries of the user
                may not be answered in a time bound manner due to a high
                volume of queries at a given point of time.
              </li>
              <li>
                You hereby agree that answers to queries requiring detailed
                and advanced graphics is outside the ambit of these terms.
                You hereby agree that we may not be able to resolve certain
                queries due to the highly complex nature of the query, due
                to our limited resource base as the answers to such queries
                can only be provided by having access to specialized and
                highly skilled resources that might not be available with
                us.
              </li>
              <li>
                You understand that model questions / sample papers and
                their answers posted on the site have been prepared by the
                site based on the limited resources and restricted access
                available at its disposal and therefore are vulnerable to
                certain errors which may inadvertently creep in despite the
                platform's best efforts. The user agrees not to hold the
                platform responsible for such errors or omissions. The
                platform does not provide any time limit or provides any
                express or implied time warranty of any kind, regarding any
                matter pertaining to this service. The platform for its
                services rendered does not provide any implied warranties of
                merchantability, fitness for a particular purpose. Glorifire
                Authors shall not be liable, at any time, for any failure of
                performance, error, omission, interruption, deletion,
                defect, delay in operation or transmission, computer virus,
                communications line failure, theft or destruction or
                unauthorized access to, alteration of, or use of information
                contained on this platform.
              </li>
              <li>
                You are aware and understand that Glorifire does not provide
                any judgment or warranty regarding the authenticity or
                correctness of the content of other services or sites that
                the screen links refer to.
              </li>
              <li>
                You are aware and understand that a link to another service
                or site is not an endorsement of the service or site and
                Glorifire Authors shall not be responsible in any manner
                whatsoever for the consequences of any act or omission on
                the part of the user on the basis of the information
                contained in such other services or sites.
              </li>
              <li>
                Glorifire Authors reserves its right to monitor the use of
                all or any part of its service without any prior intimation
                or any obligation to the user.
              </li>
              <li>
                You agree that you shall not alter the information, content
                or material or use of such information, content or material
                contained on the platform for any purpose that constitutes a
                violation of the copyright of Glorifire Authors or of a
                third-party information provider. You agree not to copy,
                reproduce, republish, upload, post, transmit or distribute
                the material in any way either in part or full, for any use
                without obtaining the prior written consent from Glorifire
                Authors. However, the use of downloadable pdf resources such
                as sample test papers and previous year papers is
                permissible but restricted to your personal use only.
              </li>
              <li>
                You agree that you shall not solicit or invite other users
                to share the credits/points/package/course/anything else
                that he earns, that accrue to him in his individual
                capacity; and agrees not to sell the
                credits/points/package/course/anything else for any
                consideration to a third party. In case of a violation of
                this condition you shall alone be liable to pay for the
                credits/points/course/package/anything else that you had
                sold or shared and shall forfeit all your
                credits/points/course/package/anything else accumulated and
                your account may be terminated.
              </li>
              <li>
                If you do not agree to any of the terms mentioned in this
                agreement, then you must exit the platform from your browser
                or application
              </li>
            </ol>
            <br />
            <b> Intellectual Property Rights</b>
            The content on the Glorifire Authors platform<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>website (or application), except all user submissions (as
            defined below), including without limitation, the text,
            software, scripts, graphics, photos, sounds, music, videos,
            interactive features and the like ("Content") and the
            trademarks, service marks and logos contained therein ("Marks"),
            are owned by or licensed to EDFORA, subject to copyright and
            other intellectual property rights under the laws of India and
            foreign laws and international conventions. Please refer to our
            Copyright Notice for further information on the subject.<br /><br />
            <b>Your Content</b>
            User Submissions
            <br /><br />
            The services provided by Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>may now or in the future permit the submission of content,
            quizzes, exams, tests, projects, and other assignments you
            submit, posts you make in the forums, videos or other
            communications submitted by you and other users ("User
            Submissions") and the hosting, sharing, and/or publishing of
            such user submissions. You understand that whether or not such
            user submissions are published, Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>does not guarantee any confidentiality with respect to any
            submissions.
            <br />
            <br />
            How Glorifire Authors may use user submission
            <br />
            <br />
            A. To the extent that you provide user submission, you grant
            Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, a fully-transferable, unlimited, irrevocable, royalty-free,
            perpetual, sub-licensable, non-exclusive, worldwide license to
            copy, distribute, modify, create derivative works based on,
            publicly perform, publicly display, and otherwise use the user
            submission. You shall be solely responsible for your own User
            submissions and the consequences of posting or publishing them.
            In connection with User submissions, you affirm, confirm,
            represent, and/or warrant that:<br /><br />
            <ol>
              <li>
                You own or have the necessary licenses, rights, consents and
                permissions to use and authorize Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>to use all patent, trademark, trade secret, copyright or
                other proprietary rights in and to any and all User
                Submissions to enable inclusion and use of the user
                submissions in the manner contemplated by the website (or
                application) and these terms of service; and
              </li>
              <li>
                You have the written consent, release, and/or permission of
                each and every identifiable individual person in the user
                submission to use the name or likeness of each and every
                such identifiable individual person to enable inclusion and
                use of the User Submissions in the manner contemplated by
                the website (or application) and these terms of service
              </li>
            </ol>
            B.In connection with user submissions, you further agree that
            you will not:
            <br /><br />
            <ol>
              <li>
                Submit material that is copyrighted, trade mark, patented,
                protected by trade secret or otherwise subject to third
                party proprietary rights, including privacy and publicity
                rights, unless you are the owner of such rights or have
                permission from their rightful owner to post the material
                and to grant Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>all of the license rights granted herein;
              </li>
              <li>
                Publish falsehoods or misrepresentations that could damage
                Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>or any third party;
              </li>
              <li>
                Submit material that is unlawful, obscene, defamatory,
                libellous, threatening, pornographic, harassing, hateful,
                racially or ethnically offensive, or encourages conduct that
                would be considered a criminal offense, give rise to civil
                liability, violate any law, or is otherwise inappropriate;
              </li>
              <li>Post advertisements or solicitations of business:;</li>
              <li>Impersonate another person.</li>
            </ol>
            C. Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>does not endorse any user submission or any opinion,
            recommendation, or advice expressed therein, and Glorifire
            Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>expressly disclaims any and all liability in connection with
            user submissions. Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>does not permit copyright infringing activities and infringement
            of intellectual property rights on its Website (or application),
            and Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>will remove all content and user submissions if properly
            notified that such content or user submission infringes on
            another's intellectual property rights. Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>reserves the right to remove content and user submissions
            without prior notice. Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>will also terminate a user's access to its website (or
            application), if they are determined to be a repeat infringer. A
            “repeat infringer” is a user who has been notified of infringing
            activity more than once and/or has had a user submission removed
            from the website more than twice.
            <br />
            <br />
            D. In particular, if you are a copyright owner or an agent
            thereof and believe that any user submission or other content
            infringes upon your copyrights, you may submit a notification in
            accordance with the Copyright Act (CA) (as applicable to India)
            by providing our company with the following information in
            writing:<br /><br />
            <ol>
              <li>
                A physical or electronic signature of a person authorized to
                act on behalf of the owner of an exclusive right that is
                allegedly infringed;
              </li>
              <li>
                Identification of the copyrighted work claimed to have been
                infringed, or, if multiple copyrighted works at a single
                online site are covered by a single notification, a
                representative list of such works at that site;
              </li>
              <li>
                Identification of the material that is claimed to be
                infringing or to be the subject of infringing activity and
                that is to be removed or access to which is to be disabled
                and information reasonably sufficient to permit the service
                provider to locate the material;
              </li>
              <li>
                Information reasonably sufficient to permit the service
                provider to contact you, such as an address, telephone
                number, and, if available, an electronic mail;
              </li>
              <li>
                A statement that you have a good faith belief that use of
                the material in the manner complained of is not authorized
                by the copyright owner, its agent, or the law; and
              </li>
              <li>
                A statement that the information in the notification is
                accurate, and under penalty of perjury, that you are
                authorized to act on behalf of the owner of an exclusive
                right that is allegedly infringed.
              </li>
            </ol>
            <br />
            <b>5. Feedback</b>
            Feedback We welcome your suggestions, ideas, comments, and other
            feedback regarding the Services ("Feedback"). By submitting any
            Feedback, you grant us the right to use the Feedback without any
            restriction or any compensation to you. By accepting your
            Feedback, Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>does not waive any rights to use similar or related Feedback
            previously known to Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, developed by its employees or contractors, or obtained from
            other sources.<br /><br />
            <b>Warranty Disclaimer and Liability</b>
            The website (or application) is controlled and offered by Edfora
            from its facilities in India. Edfora makes no representations
            that the website (or application) is appropriate or available
            for use in other locations. Those who access or use the website
            (or application) from other jurisdictions do so at their own
            volition and are responsible for compliance with local law.
            Usage of our website (or application) is subject to you agreeing
            to the warranty disclaimers. Please refer to our policy on
            warranty disclaimers and the extent of our liability in this
            regard. You agree that you have understood and agreed to terms
            stipulated therein.<br /><br />
            <b>7. Indemnity</b>
            You agree to indemnify, defend and hold harmless Edfora<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, its owners and their officers, directors, employees, agents or
            third party from and against any and all claims, damages,
            obligations, losses, liabilities, costs or debt, and expenses
            (including but not limited to attorney's fees) arising from: (i)
            your use of and access to the Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>(ii) your violation of any term of these terms of service; (iii)
            your violation of any third party right, including without
            limitation any copyright, property, or privacy right; or (iv)
            any claim that one of your user submissions caused damage to a
            third party. This defense and indemnification obligation will
            survive these terms of service and your use of Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>website (or application)<br /><br />
            <b>8. Assignment</b>
            These terms of service and any rights and licenses granted
            hereunder, may not be transferred or assigned by you, but may be
            assigned by Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>without any restriction.<br /><br />
            <b>9. General</b>
            You agree that:
            <br />
            <ol>
              <li>
                Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>website (or application) shall be deemed solely based in
                India; and
              </li>
              <li>
                Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>shall be deemed a passive website that does not give rise to
                personal jurisdiction over Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>, either specific or general, in jurisdictions other than
                New Delhi, India. These terms of service shall be governed
                by the internal substantive laws of India, without respect
                to its conflict of laws, principles. Any claim or dispute
                between you and Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>website (or application) that arises in whole or in part
                from Glorifire Authors platform shall be decided exclusively
                by a court of competent jurisdiction located in New Delhi,
                India.
              </li>
              <li>
                These Terms of Service, together with the privacy notice at<a href="https://authors.glorifire.com/privacy-policy">https://authors.glorifire.com/privacy-policy</a>and anyother legal notices published by<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>on the website (or application), shall constitute the entire
                agreement between you and Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>concerning the website (or application).
              </li>
              <li>
                If any provision of these terms of service is deemed invalid
                by a court of competent jurisdiction, the invalidity of such
                provision shall not affect the validity of the remaining
                provisions of these terms of service, which shall remain in
                full force and effect.
              </li>
              <li>
                No waiver of any term of these terms of service shall be
                deemed a further or continuing waiver of such term or any
                other term, and GlorifireAuthors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>failure to assert any right or provision under these terms
                of service shall not constitute a waiver of such right or
                provision. Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>reserves the right to amend these terms of service at any
                time and without notice, and it is your responsibility to
                review these terms of service for any changes.
              </li>
              <li>
                Your use of the website following any amendment of these
                terms of service will signify your assent to and acceptance
                of its revised terms. You and Glorifire Authors<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>agree that any cause of action arising out of or related to<a href="https://authors.glorifire.com">https://authors.glorifire.com</a>website (or application) must commence within one (1) year
                after the cause of action accrues, otherwise, such cause of
                action is permanently barred.
              </li>
            </ol><br />
            <b>10. Return Policy</b>
            <ol>
              <li>
                We do not allow any return/refund in any form once the
                product is purchased. So, you are advised to make sure that
                the correct product is purchased.
              </li>
              <li>
                Still if the wrong product is purchased by mistake, the
                issue must be reported within 24 hours. In such a scenario,
                a product can be considered for replacement with another of
                the same value under strict conditions that the already
                purchased product has not been used.
              </li>
            </ol><br />
            <b>Glorifire Community Guidelines</b>
            Glorifire community is an interactive platform to initiate
            discussions, share ideas and ask questions and resolve your
            doubts. With an ever-growing list of Glorifire users, it is
            important to abide by certain rules and guidelines in order to
            make this forum an interesting and safe experience.
            <br />
            <br />
            The moderation team of Glorifire community keeps a close watch
            over the policy violations and holds the final right to take any
            strict action, if required.<br />
            <b>Report Abuse:</b>
            If you think that any content is inappropriate, kindly use
            Report abuse to submit the same for review. Each request is
            carefully reviewed and double-checked by the quality control
            team to determine if there is a violation of our community
            policy/guidelines.
            <br />
            <br />
            For a hassle-free and wholesome Glorifire Community experience,
            follow the guidelines given below, which'll help us (and you
            too) to keep the community alive and competent:<br /><br />
            <b>1) Do not stray from the purpose of Glorifire Community</b>
            Glorifire community is an interactive teachers and student
            platform aimed at doubt resolution and knowledge sharing for
            academic purposes. Only relevant content which is posted with
            the intent of helping others will be entertained.<br /><br />
            <b>2) Categorise and tag your content appropriately</b>
            While posting any doubts/queries, make sure it is added under
            relevant tags. This helps us in redirecting the queries to the
            experts and getting faster and accurate resolution.<br /><br />
            <b>3) Do not post hateful content</b>
            Any hate speech, threats, violent and provoking content is not
            allowed. Also, do not bully, make any personal attacks (not only
            limited to hurtful), insulting, or hostile comments.<br /><br />
            <b>4) Respect the privacy of other community members</b>
            It is prohibited to share any personal information about
            individuals (without permission) which invades their privacy.<br /><br />
            <b>5) Do not spam or post promotional content</b>
            As a student/teacher driven discussion forum, we have zero
            tolerance for spam and promotional content. Any malicious and
            obscene content/links shall be removed.<br /><br />
            <b>6) Do not post any support related issues</b>
            No questions/comments regarding any Glorifire support issue will
            be entertained in the community. For such queries, reach out to
            us on<a href="mailto:support@glorifire.com">support@glorifire.com</a>. or your Glorfire Account Manager<br /><br />
            <b>7) Blocking users</b>
            If a user's content has been reported as abuse (including but
            not limited to spam, abusive attack, harassment) repetitively,
            the Glorifire Community moderator reserves the right to block
            the said user from the forum.<br /><br />
            <b>8) Unnecessary reports</b>
            In case it is found that a user is unnecessarily reporting
            quality content that adheres to guidelines, the said user shall
            be banned/blocked from using the Glorifire Community. Any
            content that violates Glorifire Community guidelines will be
            removed and the user may be blocked by moderators, resulting in
            a temporary or permanent ban from any activity on Glorifire
            Community. In case a user has been temporarily banned by the
            moderator, he/she shall receive an email informing them when the
            ban has been lifted. In case the user has been permanently
            banned from the Community, they can send an email to<a href="mailto:support@glorifire.com">support@glorifire.com</a>
            <br />
            <br />
            However, the final decision, in all cases, rests with Glorifire.
          </p>
          <br />
        </div>
      </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  userData: state.loginData.userData,
});


export default connect(
  mapStateToProps
  // @ts-ignore
)(terms);